import {
  APPLICATION_ID,
  SUCCESS_APPLICATION_LIST,
  REQUEST_APPLICATION_LIST,
  SET_APPLICATION_FLAGS
} from './types';
import * as api from '../../api/api';
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-center',
  showConfirmButton: false,
  timer: 10000,
  customClass: {
    title: 'title-class'
  }
});

export const applicationIDAction = id => {
  localStorage.setItem('id', JSON.stringify(id));
  return {
    type: APPLICATION_ID,
    payload: id
  };
};

export const initAppID = () => ({type: "INITIAL_APP_ID"});

export const applicationAction = data => {
  return {
    type: SUCCESS_APPLICATION_LIST,
    payload: data
  };
};

export const setApplicationFlags = data => ({
  type: SET_APPLICATION_FLAGS,
  payload: data
})

export const stopAssistance = () => async(dispatch, getState) => {
  dispatch({type: "REQUEST_STOP"})
  try {
    await api.StopAssistance();
    
    dispatch(getApplicationList(getState().auth.user.rnokpp));
    dispatch({type: "SUCCESS_STOP"})
  } catch (error) {
    dispatch({type: "FAILURE_STOP"})
  }
}

export const getApplicationList = id => dispatch => {
  // getApplicationDatat(id)
  dispatch({ type: REQUEST_APPLICATION_LIST });
  api.getAllApplications(id)
    .then(response => {
      dispatch(applicationAction(response.data.applicationList));
      // if (response.data.length > 0) {
      //   dispatch(getAgriment(response.data[0].id));
      // } else {
      //   dispatch(getAgriment(0));
      // }


      dispatch(setApplicationFlags(response.data.flag));

      localStorage.setItem('aplication', JSON.stringify(response.data.applicationList));
      localStorage.setItem('f', JSON.stringify(response.data.flag));
    })
    .catch(err => {
      // Toast.fire({
      //   title: 'Помилка сервера. Блок:отримання заяв.',
      //   type: 'error'
      // });
    });
};
